import { createMuiTheme } from '@material-ui/core/styles'
import deepOrange from '@material-ui/core/colors/deepOrange'

export const theme = createMuiTheme({
  palette: {
    primary: { main: '#248d44' },
    secondary: deepOrange,
  },
})
